module.exports = __webpack_public_path__ + "img/title.a564969f.jpg";